<cap-list-loader [listLoader]="listLoader" [showZeilenSelect]="showZeilenSelect">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-search">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th>
      <cap-column-header [columnName]="'Nummer'" [sortModel]="tableSortModel.columns.get('nummer')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'EGRID'" [sortModel]="tableSortModel.columns.get('egrid')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Art'" [sortModel]="tableSortModel.columns.get('art')"></cap-column-header>
    </th>
    <th>
      {{ "Kurzbeschreibung" | translate }}
    </th>
    <th>
      {{ "Adressen" | translate }}
    </th>
    <th>
      <!-- leerer header für fremdsysteme -->
    </th>
    <th>
      <!-- leerer header für auszug -->
    </th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (item of listLoader?.items | grundstueckFilter: filterTerm; track item) {
    <tr>
      <td>
        <div [capHistinfo]="item.model.histInfo">
          <cap-link
            [queryParams]="{ id: item.model.id.id }"
            [target]="navTargets.NAV_GRUNDSTUECK_ES"
            [tooltipParams]="{ nummer: item.tooltip }">
            {{ item.kompaktGrundstueck }}
          </cap-link>
        </div>
      </td>
      <td>
        <div>
          <cap-link
            [queryParams]="{ id: item.model.id.id }"
            [target]="navTargets.NAV_GRUNDSTUECK_ES"
            [tooltipParams]="{ nummer: item.tooltip }">
            {{ item.egrid }}
          </cap-link>
        </div>
      </td>
      <td>
        <div [capHistinfo]="item.model.histInfo">
          <cap-link
            [queryParams]="{ id: item.model.id.id }"
            [target]="navTargets.NAV_GRUNDSTUECK_ES"
            [tooltipParams]="{ nummer: item.tooltip }">
            {{ item.kompaktArt }}
          </cap-link>
        </div>
      </td>
      <td>
        <div [capHistinfo]="item.model.histInfo">
          <cap-link
            [queryParams]="{ id: item.model.id.id }"
            [target]="navTargets.NAV_GRUNDSTUECK_ES"
            [tooltipParams]="{ nummer: item.tooltip }">
            {{ item.kompaktKurzbeschreibung }}
          </cap-link>
        </div>
      </td>
      <td>
        <cap-link
          [queryParams]="{ id: item.model.id.id }"
          [target]="navTargets.NAV_GRUNDSTUECK_ES"
          [tooltipParams]="{ nummer: item.tooltip }">
          {{ item.kompaktAdressen }}
        </cap-link>
      </td>
      <td>
        <cap-fremdsysteme [gsEntry]="item.model" [isListEntry]="true" class="float-end"></cap-fremdsysteme>
      </td>
      <td>
        <cap-auszug-icp [gsEntry]="item.model"></cap-auszug-icp>
      </td>
    </tr>
  }
</ng-template>
